export const INVITED_STATUS = 'INVITED';
export const USER_EXISTS_STATUS = 'USER_EXISTS';

export const SUCCESSFUL_INVITE_STATUSES = [INVITED_STATUS, USER_EXISTS_STATUS];

export const INVITE_USERS_ENDPOINT = '/gateway/api/invitations/invite';

// These public keys are safe to store in code
export const RECAPTCHA_SITE_KEY_PROD = '6LfOcIYhAAAAADBS5OnBllme06dW9vyW4Zgowiru';
export const RECAPTCHA_SITE_KEY_STAGING = '6LebaYYhAAAAAKFQt-KH6vVkTJQqwZddT-HJCIM3';
export const RECAPTCHA_SITE_KEY_DEV = '6Le_DxYiAAAAABV8BsFSj3AmZf3OkP9Fh9lfbZOZ';
